import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OAuthService {
  private readonly redirectUri = `${window.location.origin}/auth/oauth/callback`;

  signInWithGoogle(): void {
    const clientId = environment.googleOAuth?.clientId;
    if (!clientId) {
      console.error('Google OAuth Client ID is not configured in environment.ts');
      return;
    }
    const state = btoa(JSON.stringify({ provider: 'Google' }));
    const params = new URLSearchParams({
      client_id: clientId,
      redirect_uri: this.redirectUri,
      response_type: 'code',
      scope: 'openid profile email',
      access_type: 'offline',
      state,
      prompt: 'consent'
    });
    window.location.href = `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
  }

  getRedirectUri(): string {
    return this.redirectUri;
  }
}
